(function () {
    'use strict';

    angular
        .module('recommendationEditModule', [
            'services.attachments',
            'actionPlanModule',
            'aricModule',
            'governanceProcessModule',
            'recommendationModule',
            'services.historyCtxt'
        ]);
})();
